import React, { useState, useContext } from "react";
import Select from "../../../components/Select";
import VistaContext from "../../context/VistaContext";
import FuncionesContext from "../../../context/FuncionesContext";

const SelectOnSubmit = ({
  data,
  cab,
  hijos,
  campokey,
  indiceData,
  id_elemento,
}) => {
  const { setFiltro } = useContext(VistaContext);
  const { refrescarConfiguracion } = useContext(FuncionesContext);
  const { id_a } = cab;

  const [value, setValue] = useState(data[campokey]);
  const [lastValue, setLastvalue] = useState(data[campokey]);

  const nombre = (() => {
    if (cab.nombre_alias) {
      return data[cab.nombre_alias];
    }
    return cab.nombre;
  })();

  const handleCancelar = () => {
    setValue(data[campokey]);
    setLastvalue(data[campokey]);
  };

  const disabled = (() => {
    if (data[cab.id_a + "_disabled"]) {
      return data[cab.id_a + "_disabled"] === "s";
    }
    if (cab.disabled) {
      return cab.disabled === "s";
    }
    return false;
  })();

  const handleChange = async (e) => {
    let valor = e.target.value;

    if (valor === null || lastValue?.toString() === valor.toString().trim())
      return;

    if (typeof cab.opciones[0].value === "number") {
      valor = parseInt(valor, 10);
    }

    setFiltro({ id_a, valor });

    if (cab.select_es_maestro === "s") {
      refrescarConfiguracion({ cab });
      return;
    }
  };

  return (
    //<div style={{ textAlign: "center"}}>
    <div id={id_elemento} style={{ flex: "1 0 100%" }}>
      <div
        className="vista_label_select"
        //style={{ fontWeight: "bold", display: "flex", width: "100%" }}
      >
        {cab.nombre && cab.nombre !== "" ? (
          <p style={{ flexShrink: 0, flexWrap: "wrap" }}>{cab.nombre}:</p>
        ) : (
          <></>
        )}
        <Select
          nombre={nombre}
          opciones={cab.opciones ? cab.opciones : []}
          value={value}
          onChange={handleChange}
          def={cab.default}
          disabled={disabled}
        />
        {hijos}
      </div>
    </div>
  );
};

export default SelectOnSubmit;
